import { render, staticRenderFns } from "./harmonious_Video_Exhibition_2025_detail.vue?vue&type=template&id=2478f3a4&scoped=true"
import script from "./harmonious_Video_Exhibition_2025_detail.vue?vue&type=script&lang=js"
export * from "./harmonious_Video_Exhibition_2025_detail.vue?vue&type=script&lang=js"
import style0 from "./harmonious_Video_Exhibition_2025_detail.vue?vue&type=style&index=0&id=2478f3a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478f3a4",
  null
  
)

export default component.exports